import React, { useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import "antd/dist/antd.css";

import Form from "./layout/liveChat";
import LoginWithEhr from "./components/ehr-login/loginWithEhr";
import Login from "./components/login/login";
import Authenticate from "./components/auth/requireAuths";
import history from "./history";
import Epic from "./components/epicRedirect";
import Smart from "./components/epicRedirect/smart";
import Broadcast from "./layout/broadcast";
import PatientReport from "./layout/patientReport";
import Logs from "./layout/logs";
import BroadcastReport from "./layout/broadcastReport";
import "./helper/interceptor";
import PatientUpload from "./components/patient-upload";
import logout from "../src/components/logout";
import UserNotFound from "../src/components/userNotFound";
import LoginOtp from "./components/loginOtp/loginOtp";
import ForgetPassword from "./components/forgotPassword/forgotPassword";
import SetPassword from "./components/setPassword/setPassword";
import UserProfile from "./layout/userProfile";
import LiveAgent from "./layout/liveAgent";
import SingleSignOn from "./components/single-signon";
import Errors from "./layout/errors/errors";
import ErrorBoundary from "./components/errorBoundary";
import { getFaviconBasedOnEHR, getLabelBasedOnEHR } from "./helper/helpers";
import { EHR_NAME } from "./constants/constants";
import AdminLogin from "./components/adminLogin/adminLogin";
import LoginByDept from "./components/loginByDept/loginByDept";
import { useSelector } from "react-redux";
import MessageLog from "./layout/messageLog";

const App = () => {
  // theme condition based on EHR
  const currentUser = useSelector((state) => state.login.user);

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    const ehrTitle = getLabelBasedOnEHR();
    document.title = ehrTitle;
    document.body.setAttribute("data-ehr-type", EHR_NAME?.toLowerCase());
    favicon.href = getFaviconBasedOnEHR();
    if ("Notification" in window) {
      requestNotificationPermission(currentUser);
    }
  }, []);

  const requestNotificationPermission = async (currentUser) => {
    let permission = Notification.permission;
    if (permission === "default" && currentUser.liveChatNotifications) {
      permission = await Notification.requestPermission();
    }
  };

  return (
    <Router history={history}>
      <ErrorBoundary>
        <Switch key={currentUser?.lcUser}>
          <Route exact path="/" component={Login} />
          <Route exact path="/otp" component={LoginOtp} />
          <Route exact path="/admin-login" component={AdminLogin} />
          <Route exact path="/login-by-dept" component={LoginByDept} />
          <Route exact path="/sso/:token" component={SingleSignOn} />
          <Route exact path="/forgetpassword" component={ForgetPassword} />
          <Route exact path="/logout" component={logout} />
          <Route exact path="/setpassword" component={SetPassword} />
          <Route exact path="/userNotFound" component={UserNotFound} />
          <Route exact path="/LoginWithEhr" component={LoginWithEhr} />
          <Route exact path="/chat" component={Authenticate(Form)} />
          <Route exact path="/chat-agent" component={LiveAgent} />
          <Route exact path="/error" component={Errors} />
          <Route
            exact
            path="/chat/report"
            component={Authenticate(PatientReport)}
          />
          <Route exact path="/logs" component={Authenticate(Logs)} />
          <Route exact path="/upload/:patientid" component={PatientUpload} />
          <Route
            exact
            path="/upload/:departmentId/:patientid"
            component={PatientUpload}
          />
          <Route exact path="/broadcast" component={Authenticate(Broadcast)} />
          <Route
            exact
            path="/broadcast/report"
            component={Authenticate(BroadcastReport)}
          />
          <Route
            exact
            path="/broadcast/messageLog"
            component={Authenticate(MessageLog)}
          />

          <Route exact path="/epic/:token?" component={Epic} />
          <Route exact path="/smart" component={Smart} />
          <Route exact path="/profile" component={Authenticate(UserProfile)} />
          <Route
            exact
            path="/help"
            component={() => {
              window.location.href = "https://docs.myhousecallspro.com";
              return null;
            }}
          />
          <Redirect to="/" />
        </Switch>
      </ErrorBoundary>
    </Router>
  );
};
export default App;
